import { apiDataService } from "@/services/apiDataService";
export default {
	namespaced: true,
	state: {
		organizers: [],
		error: null,
		loading: false,
	},
	mutations: {
		SET_ORGANIZER(state, organizers) {
			state.organizers = organizers;
			console.log("Vuex state.organizers now:", state.organizers);
		},
		SET_ERROR(state, error) {
			state.error = error;
		},
		SET_LOADING(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		async fetchAllOrganizers({ commit }) {
			commit("SET_LOADING", true);
			commit("SET_ERROR", null);
			try {
				const response = await apiDataService.getOrganizations();
				commit("SET_ORGANIZER", response.data);
			} catch (error) {
				commit("SET_ERROR", error.message || "Failed to fetch events");
			} finally {
				commit("SET_LOADING", false);
			}
		},
	},
	getters: {
		allOrganizer: (state) => state.organizers,
		fetchError: (state) => state.error,
		isLoading: (state) => state.loading,
	},
};
